import React from 'react';
import { Link } from 'react-router-dom';

const NewTechnologySection = () => {
	return (
		<>
			<section className="section-sp1">
				<div className="container">
					<div className="row justify-content-center">
						<div className="col-lg-10 text-center">
							<div className="heading-bx text-center">
								<h6 className="title-ext text-secondary">Advanced Technology</h6>
								<h2 className="title">Modern Dental Care Backed by Innovation</h2>
								<p>
									Our office uses advanced dental technology to make your visits more precise,
									comfortable, and efficient. From digital imaging to modern treatment tools,
									every step is designed to support better outcomes and a smoother patient
									experience.
								</p>
							</div>
							<Link to="/new-technology" className="btn btn-primary shadow">
								Read More
							</Link>
						</div>
					</div>
				</div>
			</section>
		</>
	);
};

export default NewTechnologySection;
